<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="web-form">
                <div class="title-col">
                    <h2>Confirm your email address</h2>
                    <p>Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you?</p>
                    <p>&nbsp;</p>
                    <p>If you didn't receive the email, we will gladly send you another.</p>
                </div>
                <form class="form-style" @submit.prevent="submit">

                    <div class="mb-4 font-medium text-sm text-green-600" v-if="verificationLinkSent" >
                        A new verification link has been sent to the email address you provided during registration.
                    </div>

                    <form @submit.prevent="submit">
                        <div class="mt-4 flex items-center justify-between">
                            <jet-button :class="{ 'disabled': form.processing }" :disabled="form.processing">
                                Resend Verification Email
                            </jet-button>

                            <inertia-link :href="route('logout')" method="post" as="button" class="btn btn-secondary btn-style">
                                <span>Logout</span>
                            </inertia-link>
                        </div>
                    </form>
                </form>
            </div>
        </div>
    </guest-layout>
</template>

<script>
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
    import JetButton from '@/Jetstream/Button'
    import GuestLayout from "@/Layouts/GuestLayout";

    export default {
        components: {
            GuestLayout,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form()
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('verification.send'))
            },
        },

        computed: {
            verificationLinkSent() {
                return this.status === 'verification-link-sent';
            }
        }
    }
</script>
